/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Model_Downgraded_EntitlementInputs */

const en_model_downgraded_entitlement = /** @type {(inputs: Model_Downgraded_EntitlementInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your plan doesn't include ${i?.from} — this used ${i?.to}.`)
};

const id_model_downgraded_entitlement = /** @type {(inputs: Model_Downgraded_EntitlementInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paketmu belum termasuk ${i?.from} — hasil ini memakai ${i?.to}.`)
};

/**
* | output |
* | --- |
* | "Your plan doesn't include {from} — this used {to}." |
*
* @param {Model_Downgraded_EntitlementInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_downgraded_entitlement = /** @type {((inputs: Model_Downgraded_EntitlementInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Downgraded_EntitlementInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_downgraded_entitlement(inputs)
	return en_model_downgraded_entitlement(inputs)
});